import React from 'react'

import Map from '@components/GymSearchMap'

import MapWrapper from './GymSearchMap.style'

function GymSearchMap() {
  return (
    <MapWrapper>
      <Map />
    </MapWrapper>
  )
}

export default GymSearchMap
